import { isEmpty } from 'lodash/fp';
import { createSelector } from 'reselect';
import { makeFetchAction } from 'redux-api-call';

import { API_ADMIN_ENDPOINT } from '../../utils/envConfig';

const CREATE_ADMIN_SESSION_API_ID = 'admin/LOGIN';

const {
  actionCreator: createSessionAC,
  dataSelector: sessionDataSelector,
  errorSelector: createSessionErrorSelector,
  isFetchingSelector: isLoggingInSelector,
} = makeFetchAction(CREATE_ADMIN_SESSION_API_ID, ({ email, password }) => ({
  endpoint: `${API_ADMIN_ENDPOINT}/session`,
  method: 'POST',
  body: { email, password },
}));

const loginErrorSelector = createSelector(
  createSessionErrorSelector,
  error => (isEmpty(error) ? null : 'Incorrect email or password.')
);

export {
  CREATE_ADMIN_SESSION_API_ID,
  createSessionAC,
  sessionDataSelector,
  loginErrorSelector,
  isLoggingInSelector,
};
